/**
 * Notifications REST client (v4.1 Phase 38.2).
 *
 * Self-scoped at the API layer — every caller reads only their own
 * notifications by virtue of the JWT sub. No role checks needed.
 */

import { request } from "./api.js";

export const listNotifications = ({ unreadOnly = false, limit = 50 } = {}) => {
  const params = new URLSearchParams();
  if (unreadOnly) params.set("unreadOnly", "true");
  if (limit) params.set("limit", String(limit));
  const qs = params.toString();
  return request(`/api/notifications${qs ? `?${qs}` : ""}`);
};

export const markNotificationRead = (notificationId) =>
  request(`/api/notifications/${encodeURIComponent(notificationId)}/read`, {
    method: "POST",
  });

export const markAllNotificationsRead = () =>
  request("/api/notifications/mark-all-read", { method: "POST" });
